import React from 'react'
import {UseFormMethods} from 'react-hook-form'
import BackgroundSection from 'Event/Dashboard/components/CountDownTimer/CountDownTimerConfig/Styling/BackgroundSection'
import TypographySection from 'Event/Dashboard/components/CountDownTimer/CountDownTimerConfig/Styling/TypographySection'
import UnitBackgroundSection from 'Event/Dashboard/components/CountDownTimer/CountDownTimerConfig/Styling/UnitBackgroundSection'
import AdditionalSection from 'Event/Dashboard/components/CountDownTimer/CountDownTimerConfig/Styling/AdditionalSection'
import {CountDownTimerSettings} from 'Event/Dashboard/components/CountDownTimer'

export default function Styling(props: {
  control: UseFormMethods['control']
  countDownTimer: CountDownTimerSettings
  namePrefix?: string
}) {
  const {control, countDownTimer, namePrefix = ''} = props

  return (
    <>
      <BackgroundSection
        countDownTimer={countDownTimer}
        control={control}
        namePrefix={namePrefix}
      />
      <UnitBackgroundSection
        countDownTimer={countDownTimer}
        control={control}
        namePrefix={namePrefix}
      />
      <TypographySection
        countDownTimer={countDownTimer}
        control={control}
        namePrefix={namePrefix}
      />
      <AdditionalSection
        countDownTimer={countDownTimer}
        control={control}
        namePrefix={namePrefix}
      />
    </>
  )
}
